import { configureStore } from "@reduxjs/toolkit";
import envReducer from "../components/Common/Store/EnvSlice";
import peopleReducer from "../components/Common/Store/MgtSlice";
import entriesReducer from "../components/Entry/EntrySlice";
import rolesReducer from "../components/Roles/RolesSlice";
import userReducer from "../components/User/UserSlice";

export default configureStore({
  reducer: {
    roles: rolesReducer,
    entries: entriesReducer,
    people: peopleReducer,
    user: userReducer,
    env: envReducer,
  },
});
